const Sumo = {
  symbol: 'sumo',
  color: '#000',
  plainIcon: c => {
    return `<path fill="${
      c ? c : this.color
    }" d="M16 32C7.163 32 0 24.837 0 16S7.163 0 16 0s16 7.163 16 16-7.163 16-16 16zm2.061-22.916H13.99C10.977 12.446 9.514 13.828 7 15.9l10.81 2.338-1.86 2.09c-2.483-1.47-4.183-1.659-7.24-1.94 2.297 1.058 3.49 1.908 5.279 4.526h4.072c2.115-2.627 3.573-4.152 6.939-7.014l-10.76-2.39 1.71-1.99c2.709 1.422 4.331 1.626 7.206 1.986-.827-.227-1.691-.857-5.095-4.423zm-3.821-.497h3.57C16.919 7.475 16.54 6.912 16.05 6c-.499.885-.88 1.442-1.81 2.587zm3.57 14.826h-3.57c.89 1.112 1.27 1.675 1.76 2.587.498-.885.879-1.442 1.81-2.587z"/>`;
  },
  colorIcon() {
    return `<g fill="none"><circle cx="16" cy="16" r="16" fill="#2D9CDB"/><path fill="#FFF" d="M18.061 9.084c3.404 3.566 4.268 4.196 5.095 4.423-2.875-.36-4.497-.564-7.206-1.986l-1.71 1.99L25 15.9c-3.366 2.862-4.824 4.387-6.939 7.014H13.99c-1.789-2.618-2.982-3.468-5.28-4.527 3.058.282 4.758.47 7.24 1.94l1.861-2.09L7 15.9c2.514-2.072 3.977-3.454 6.989-6.816h4.072zm-3.821-.497c.93-1.145 1.31-1.702 1.81-2.587.49.912.869 1.475 1.76 2.587h-3.57zm3.57 14.826C16.879 24.558 16.498 25.115 16 26c-.49-.912-.87-1.475-1.76-2.587h3.57z"/></g>`;
  }
};
export default Sumo;



//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-cryptoicon/src/icons/sumo.js
// module id = null
// module chunks = 